import { Maatregel, VsmStatus } from "@/entities/vsm";
import { createContext, useContext } from "react";

export type VsmActieDialogContextType = {
    oudeToelichting: string;
    oudeStatus: VsmStatus;
    oudeMaatregelen: Maatregel[];
};

export const VsmActieDialogContext = createContext<VsmActieDialogContextType | null>(null);

export const useVsmActieDialogContext = (): VsmActieDialogContextType => {
    const context = useContext(VsmActieDialogContext);
    if (!context) {
        throw new Error("useVsmActieDialogContext must be used within a VsmActieDialogContextProvider");
    }
    return context;
};

export const useOudeMaatregelen = (): Maatregel[] => {
    const context = useContext(VsmActieDialogContext);
    if (!context) {
        throw new Error("useOudeMaatregelen must be used within a VsmActieDialogContextProvider");
    }
    return context.oudeMaatregelen;
};
